import * as types from "../constants/actionTypes";
import initialstate from "./initialState";

export default (state = initialstate.lang, action) => {
  switch (action.type) {
    case types.CHANGE_LANG:
      return action.payload;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/langReducer.js